function checkStatus(response) {
  if (response.status < 200 && response.status >= 300) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }

  return response;
}

export default function fetchJSON(...params) {
  return fetch(...params)
    .then(checkStatus)
    .then(response => response.json());
}



/** WEBPACK FOOTER **
 ** ./src/utils/fetchJSON.js
 **/